import script from "./RoleSectionTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleSectionTable.vue?vue&type=script&setup=true&lang=ts"

import "./RoleSectionTable.vue?vue&type=style&index=0&id=4064581d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4064581d"]])

export default __exports__